export const tracking = {
  0: "0.25%",
  1: "0.25%",
  2: "0",
  3: "0",
  4: "-0.25%",
  5: "-0.5%",
  6: "-0.625%",
  7: "-0.75%",
  8: "-1%",
  9: "-2.5%",
};
